<script setup lang="ts">
import { createInput } from '@formkit/vue'
import DateInput from './CreateInputBase/Date.vue'

const dateInput = createInput(DateInput, { props: ['transformDate', 'inputType', 'disabled', 'size', 'showRelativeYears'] })
</script>

<template>
  <FormKit :type="dateInput" />
</template>
